export default __webpack_public_path__ + "static/media/on-icon.9ba663ca.svg";